import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import classes from './rightBar.module.scss';
import Chat from './Chat/Chat';
import Notifications from './Notifications/Notifications';
import { getNotificationCountRequest, readMessage } from '../../store/actions/rightBar';
import accountHelpers from '../../utils/accountHelpers';

const transitionStyle = 'left 200ms, right 200ms';

const tabs = [
  {
    name: 'chat',
    content: <Chat />,
  },
  {
    name: 'notifications',
    content: <Notifications />,
  },
];

const RightBar = ({ show, currentTab, setCurrentTab }) => {
  const isPatient = accountHelpers.isInOneOfRoles(['Patient']);

  const dispatch = useDispatch();
  const { newMessagesCount, notificationUnreadCount } = useSelector((store) => store.rightBar);
  const [sizes, changeSizes] = useState(null);
  const chatHeaderRef = useRef(null);

  const changeTabs = ({ target }, name) => {
    setCurrentTab(name);

    const rootBounds = chatHeaderRef.current.getBoundingClientRect();
    const bounds = target.getBoundingClientRect();

    const left = bounds.left - rootBounds.left;
    const right = rootBounds.right - bounds.right;

    changeSizes({ left, right });

    if (newMessagesCount) dispatch(readMessage());
  };

  const getUnderlineStyle = () => {
    if (!sizes) {
      return { left: '15px', right: '143px' };
    }

    return {
      left: `${sizes.left}px`,
      right: `${sizes.right}px`,
      transition: transitionStyle,
    };
  };

  const barWrapperCls = [classes.bar_wrapper];

  if (show) barWrapperCls.push(classes.show);

  useEffect(() => {
    dispatch(getNotificationCountRequest());
  }, []);

  return (
    createPortal(
      <div
        className={barWrapperCls.join(' ')}
      >
        <div ref={chatHeaderRef} className={classes.chat_notification_wrapper}>
          {!isPatient && (
            <div
              role="button"
              tabIndex="0"
              className={`${classes.tab_title} ${currentTab === 'chat' ? classes.active : ''}`}
              onClick={(e) => changeTabs(e, 'chat')}
            >
              Chat

              {!!newMessagesCount && currentTab !== 'chat'
                && <div className={classes.count}>{newMessagesCount}</div>}
            </div>
          )}

          <div
            className={`${classes.tab_title} ${currentTab === 'notifications' ? classes.active : ''}`}
            onClick={(e) => changeTabs(e, 'notifications')}
          >
            Notifications

            {!!notificationUnreadCount && <div className={classes.count}>{notificationUnreadCount}</div>}
          </div>

          <div className={classes.tabs_underline} style={getUnderlineStyle()} />
        </div>

        <div className={classes.tab_content}>
          {tabs.find(({ name }) => name === currentTab).content}
        </div>
      </div>,
      document.getElementById('root') || document.body,
    )
  );
};

RightBar.propTypes = {

};

export default RightBar;
